const initialState = {};
const companyGroupListDropdown = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_COMPANY_GROUP_DROPDOWN_LIST':
      return { ...action.payload };
    default:
      return state;
  }
};

export default companyGroupListDropdown;
